export default "__VITE_ASSET__c4417bb9__"